import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { LanguageModel } from 'projects/core/src/lib/models/language.model';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-language-list',
  templateUrl: './language-list.component.html',
  styleUrls: ['./language-list.component.scss']
})
export class LanguageListComponent extends BaseList implements OnInit {

  public languages: Array<LanguageModel> = [];
  public apiUrl = '/languages';

  protected rightLoad = 'admin.language.list';
  protected rightNew = 'admin.language.create';
  protected rightOpen = 'admin.language.show';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected auth: AuthStateService,
    public transloco: TranslocoService
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.languages'));
    this.loadList();
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('languages').subscribe({
      next: (languages: any) => {
        this.languages = [];
        languages.data.forEach((language: any) => {
          this.languages.push(new LanguageModel().deserialize(language));
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

}
